"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mtZones = void 0;
var mtZones = exports.mtZones = [{
  id: 'LA_VALETTE',
  name: 'La Valette',
  country: 'MT',
  cornerNW: {
    latitude: 35.9042,
    longitude: 14.4908
  },
  cornerSE: {
    latitude: 35.8989,
    longitude: 14.5145
  },
  subZones: [{
    name: 'La Valette Centre historique',
    zipcodes: {
      'MSD 1001': {
        label: 'MSD 1001'
      }
    }
  }, {
    name: 'La Valette Port',
    zipcodes: {
      'MSD 1105': {
        label: 'MSD 1105'
      }
    }
  }, {
    name: 'La Valette Floriana',
    zipcodes: {
      'MSD 1600': {
        label: 'MSD 1600'
      }
    }
  }, {
    name: 'La Valette Quartier commercial',
    zipcodes: {
      'MSD 2691': {
        label: 'MSD 2691'
      }
    }
  }]
}];